
import { useNavigate } from 'react-router-dom';

export function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-car-line text-2xl text-black"></i>
              </div>
              <h3 className="text-2xl font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
                Georgia Dealer License Course
              </h3>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              Helping entrepreneurs successfully obtain their Georgia used car dealer license with our comprehensive step-by-step course and expert guidance.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-white"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-xl font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-4">
              <li>
                <button 
                  onClick={() => handleNavClick('/course')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  Course Overview
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/purchase')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  Get Started
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/consulting')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  Consulting
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/resources')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  Resources
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/faq')}
                  className="text-gray-400 hover:text-yellow-400 transition-colors cursor-pointer"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-xl font-semibold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-center text-gray-400">
                <i className="ri-phone-line mr-3"></i>
                <a href="tel:+1-555-123-4567" className="hover:text-yellow-400 transition-colors">
                  (555) 123-4567
                </a>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-mail-line mr-3"></i>
                <a href="mailto:Info@georgiadealerlicense.com" className="hover:text-yellow-400 transition-colors">
                  Info@georgiadealerlicense.com
                </a>
              </li>
              <li className="flex items-start text-gray-400">
                <i className="ri-map-pin-line mr-3 mt-1"></i>
                <span>Atlanta, Georgia<br />United States</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Georgia Dealer License Course. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <button 
                onClick={() => handleNavClick('/privacy')}
                className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => handleNavClick('/terms')}
                className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer"
              >
                Terms of Service
              </button>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-yellow-400 text-sm transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
